import React from 'react'
import { any, async, fromJSX, nothing, Updater, Widget } from 'widgets-for-react'

import {
  OpleidingenOverviewPageState,
  opleidingenOverviewStateUpdaters,
  OpleidingFilter,
  OverviewCourseItem,
  PAGE_SIZE,
} from './opleidingenOverviewState'
import { OpleidingenOverviewLayout } from './opleidingenOverviewLayout'
import { GenericPageHeader } from '../cmsPage/pages/generic'
import { getCookie } from '../../utils/cookies'
import { PageResult } from '../cmsPage/sharepointPageApi/types/pageData'
import { BlocksState } from '../cmsPage/blocks/blocksState'
import { blocksWidget } from '../cmsPage/blocks/blocksWidget'
import { CookiebarState } from '../cookiebar/cookiebarState'

export const opleidingenOverviewWidget = (
  setCookiebarState: (_: Updater<CookiebarState>) => void,
  state: OpleidingenOverviewPageState
): Widget<Updater<OpleidingenOverviewPageState>> => {
  return any([
    async<OpleidingFilter[]>(state.filters).map(opleidingenOverviewStateUpdaters.updateFilters),
    async<PageResult<OverviewCourseItem>>(state.opleidingen).map(opleidingenOverviewStateUpdaters.updateOpleidingen),
    async<BlocksState>(state.blocks).map(opleidingenOverviewStateUpdaters.updateOpleidingenBlocks),
    fromJSX(() => {
      return (
        <GenericPageHeader
          readSpeakerCookieAccepted={getCookie('readspeaker-cookies') === 'yes'}
          path={'/opleidingen'}
          parent={{
            kind: 'l',
            v: {},
          }}
          title={'Opleidingen'}
        />
      )
    }),
    fromJSX((setState) => {
      return (
        <OpleidingenOverviewLayout
          state={state}
          setIndividualFilter={(filterName, isSelected) =>
            setState(opleidingenOverviewStateUpdaters.updateIndividualFilter(filterName, isSelected))
          }
          setQuery={(newQuery) => setState(opleidingenOverviewStateUpdaters.updateQuery(newQuery))}
          setOpenMobileSidebar={(isOpen) => setState(opleidingenOverviewStateUpdaters.updateOpenMobileSidebar(isOpen))}
        />
      )
    }),
    state.blocks.kind === 'loaded'
      ? blocksWidget(setCookiebarState)(state.blocks.value).map(
          (updater: Updater<BlocksState>) =>
            (state: OpleidingenOverviewPageState): OpleidingenOverviewPageState => ({
              ...state,
              blocks:
                state.blocks.kind === 'loaded' ? { ...state.blocks, value: updater(state.blocks.value) } : state.blocks,
            })
        )
      : nothing(),
  ])
}
